import { BaseElement } from './base-element';
import { ElementType } from './element-type';

export class Section extends BaseElement {
  header: string | null = null;
  info: string | null = null;

  constructor() {
    super();
    this.elementType = ElementType.section;
  }
}
